export default __webpack_public_path__ + "static/media/pic8.78202bf2.jpg";